import CompareZoomOverlay from './CompareZoomOverlay';

export default CompareZoomOverlay;